module.exports = __webpack_public_path__ + "94ed0599decf7d10d182def0352b4f51.svg";